import React, { useState, useEffect } from 'react';
import { levelService } from '../api/services';
import './LevelBadge.css';

const LevelBadge = ({ userId, compact = false }) => {
  const [levelData, setLevelData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    const fetchLevel = async () => {
      try {
        const res = await levelService.getUserLevel(userId);
        setLevelData(res.data);
      } catch (err) {
        console.error('Failed to load level:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchLevel();
  }, [userId]);

  if (loading || !levelData) return null;

  const { level, currentExp, requiredExp, percentage, config } = levelData;

  if (compact) {
    return (
      <span
        className="level-tag-compact"
        style={{
          color: config.tag_color,
          backgroundColor: config.tag_bg_color,
        }}
        title={`${config.name} - ${percentage}%`}
      >
        {config.tag_label || `Lv.${level}`}
      </span>
    );
  }

  return (
    <div className="level-badge">
      <div className="level-info-row">
        <span
          className="level-tag"
          style={{
            color: config.tag_color,
            backgroundColor: config.tag_bg_color,
          }}
        >
          {config.tag_label || `Lv.${level}`}
        </span>
        <span className="level-name" style={{ color: config.color }}>
          {config.name}
        </span>
      </div>
      <div className="exp-bar-container">
        <div className="exp-bar-bg">
          <div
            className="exp-bar-fill"
            style={{
              width: `${percentage}%`,
              background: `linear-gradient(90deg, ${config.color}88, ${config.color})`,
            }}
          />
        </div>
        <div className="exp-text">
          <span className="exp-fraction">
            {currentExp} / {requiredExp}
          </span>
          <span className="exp-percent">{percentage}%</span>
        </div>
      </div>
    </div>
  );
};

export default LevelBadge;

